<template>
    <div>
        <label for="account_id" class="sr-only">Reference ID</label>
        <div class="relative rounded-md shadow-sm">
            <input :value="accountId" @input="$emit('update:account_id', $event.target.value)" type="text" name="account_id" id="account_id" :class="`z-0 focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full py-3 pl-4 pr-10 sm:text-sm border-gray-300 rounded-md placeholder-gray-300`" placeholder="Reference ID">
            <div
                v-if="$parent.$parent.hasFindReferenceHelp"
                @click="$emit('show-find-reference')" class="absolute z-10 inset-y-0 right-0 pr-3 flex items-center cursor-pointer">
                <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['account_id'],

        computed: {
            accountId() {
                return this.account_id;
            }
        }
    }
</script>
